// The action must match the action validated by backend-portal for each endpoint
export enum TURNSTILE_ACTION {
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot-password',
  OTP_SEND = 'otp-send',
}

export const TURNSTILE_SCRIPT_URL =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

// Overall time budget for the token generation (script load + challenge
// attempts). Kept above 10s so slow networks (e.g. 4G, cold cache) can still
// fit the script download plus up to 3 challenge attempts.
export const TURNSTILE_TIMEOUT_MS = 30000;

// Total challenge attempts per request (initial + retries) when relying on the
// script's built-in auto-retry. Bounds crash-retries, which are scheduled at 0ms.
export const TURNSTILE_MAX_ATTEMPTS = 3;
